<ng-template #stackedMember>
    <tr>
        <td class="text text-large text-reg-highlighted"
            [ngClass]="{ 'has-energy-efficiency-class has-energy-efficiency-class--small': line.energyEfficiencyClass}">
            {{ 'productPrices.memberPrice' | translateSafe }}
        </td>
        <td class="data-stacked data-reg-large data-reg-highlighted">
            <app-product-energy-class [unitPrice]="line.unitPrice" [energyEfficiencyClass]="line.energyEfficiencyClass"
                                      [energyEfficiencyProductSheetURL]="line.energyEfficiencyProductSheetURL"></app-product-energy-class>
        </td>
    </tr>
    <tr class="discount discount-row">
        <td class="text emphasis">{{ 'productPrices.discount' | translateSafe }}</td>
        <td class="data-stacked">{{ line.discountAmount }}</td>
    </tr>
    <tr class="kk-muted">
        <td class="text">{{ 'productPrices.notMemberPrice' | translateSafe }}</td>
        <td class="data-stacked">{{ line.unitPriceBeforeDiscount }}</td>
    </tr>
</ng-template>

<ng-template #stackedNormal>
    <tr>
        <td class="text text-large text-vertical-top"
            [ngClass]="{ 'has-energy-efficiency-class': line.energyEfficiencyClass}">
            {{ (line.onSale ? 'productPrices.discountPrice' : 'productPrices.price') | translateSafe }}
        </td>
        <td class="data-stacked data-stacked-large">
            <app-product-energy-class [unitPrice]="line.unitPrice" [energyEfficiencyClass]="line.energyEfficiencyClass"
                                      [energyEfficiencyProductSheetURL]="line.energyEfficiencyProductSheetURL"></app-product-energy-class>
        </td>
    </tr>
    <tr *ngIf="line.onSale" class="discount discount-row">
        <td class="text emphasis">{{ 'productPrices.save' | translateSafe }}</td>
        <td class="data-stacked">{{ line.discountAmount }}</td>
    </tr>
    <tr *ngIf="line.onSale" class="kk-muted">
        <td class="text">{{ 'productPrices.previousPrice' | translateSafe }}</td>
        <td class="data-stacked kk-line-through">{{ line.unitPriceBeforeDiscount }}</td>
    </tr>
</ng-template>

<table [ngClass]="{ 'kk-visuallyhidden': type !== 'stacked' }" *ngIf="line">
    <caption class="kk-visuallyhidden">
        {{
            'productPrices.caption' | translateSafe
        }}
    </caption>
    <tbody>
    <ng-container [ngSwitch]="type">
        <ng-container *ngSwitchCase="'stacked'">
            <ng-container
                *ngTemplateOutlet="
                    (line.activeCampaigns | isMemberType : 'MemberCustomersOnly') ? stackedMember : stackedNormal
                "
            ></ng-container>

            <tr *ngIf="(settingsService.settings$ | async)?.anydaySettings?.enableWidget && !line.isGiftCard">
                <td colspan="2">
                    <app-product-price-anyday [unitPrice]="line.unitPrice"></app-product-price-anyday>
                </td>
            </tr>
            <tr *ngIf="line.activeCampaigns | campaignOnUse : line?.campaignOnUse as campaign">
                <td colspan="2">
                    <app-product-campaign [campaign]="campaign"></app-product-campaign>
                </td>
            </tr>
            <tr *ngIf="line.points && settings.showPoints" class="point-row">
                <td class="text" colspan="2">
                    <span class="earn-points-text">
                        {{ 'productPrices.earnPoints.lite' | translateSafe : { points: line.points } }}
                    </span>
                    <span class="tooltip-wrapper">
                        <app-tooltip>
                            {{ 'productPrices.tooltipText' | translateSafe }}
                        </app-tooltip>
                    </span>
                </td>
            </tr>
        </ng-container>

        <ng-container *ngSwitchCase="['lite', 'regular'].includes(type)">
            <tr *ngIf="line.unitPrice">
                <td>{{ 'productPrices.price' | translateSafe }}</td>
                <td>{{ line.unitPrice }}</td>
            </tr>
            <tr *ngIf="line.onSale">
                <td>{{ 'productPrices.save' | translateSafe }}</td>
                <td>{{ line.discountAmount }}</td>
            </tr>
            <tr *ngIf="line.onSale">
                <td>{{ 'productPrices.previousPrice' | translateSafe }}</td>
                <td>{{ line.unitPriceBeforeDiscount }}</td>
            </tr>
            <tr *ngIf="line.points && settings.showPoints">
                <td colspan="2">{{ 'productPrices.earnPoints.lite' | translateSafe : { points: line.points } }}</td>
            </tr>
        </ng-container>
    </ng-container>
    </tbody>
</table>

<!--
    Because of styling limitations with tables, we have two times 'lite' or 'regular' markup.
    The table data for users with screenreaders, and this for sighted users
-->
<div *ngIf="type !== 'stacked'" aria-hidden="true">
    <div
        class="price-wrapper"
        [ngClass]="{ 'price-wrapper_equal-height': settings.forceEqualHeight && type === 'lite' }"
    >
        <span class="current-price">
            <span
                class="text previous kk-muted"
                [ngClass]="{ 'kk-line-through': !(line.activeCampaigns | isMemberType : 'MemberCustomersOnly') }"
                *ngIf="type === 'regular'"
            >
                <ng-container *ngIf="line.onSale">
                    {{
                        (line.activeCampaigns | isMemberType : 'MemberCustomersOnly')
                            ? ('productPrices.notMemberPrice' | translateSafe)
                            : ''
                    }}
                    {{ line.unitPriceBeforeDiscount }}
                </ng-container>
            </span>
        </span>
    </div>

    <div
        class="price-wrapper"
        [ngClass]="{ 'price-wrapper_equal-height': settings.forceEqualHeight && type === 'lite' }"
    >
        <span *ngIf="line.onSale" class="discount-price">
            <ng-container *ngIf="type === 'lite'">
                <span class="uppercase text-discount discount">{{ 'productPrices.save' | translateSafe }}</span>
                <span class="data-reg discount">{{ line.discountAmount }}</span>
            </ng-container>
            <ng-container *ngIf="type === 'regular'">
                <span class="uppercase text-discount data-reg discount"
                >{{ 'productPrices.save' | translateSafe }} {{ line.discountAmount }}</span
                >
            </ng-container>
        </span>
        <span class="current-price">
            <span
                class="data-reg"
                [ngClass]="{
                    'data-reg-large': type === 'lite',
                    'data-reg-extra-large': type === 'regular',
                    'data-reg-highlighted': (line.activeCampaigns | isMemberType : 'MemberCustomersOnly')
                }"
            >{{ line.unitPrice }}</span
            >
        </span>
    </div>
    <div class="bottom" *ngIf="settings.showPoints" [ngClass]="{ 'point-wrapper': pointPosition === 'left' }">
        <div
            *ngIf="line.points && pointPosition === 'left'"
            class="points-alternate points-left"
            [ngClass]="{ 'points-only-mobile': type === 'lite' }"
        >
            {{ 'productPrices.earnPoints.lite' | translateSafe : { points: line.points } }}
        </div>
        <span *ngIf="type === 'lite'" class="text kk-muted kk-line-through previous-lite">
            <ng-container *ngIf="line.onSale">
                {{ line.unitPriceBeforeDiscount }}
            </ng-container>
        </span>
    </div>
    <div *ngIf="line.points && pointPosition === 'below' && settings.showPoints" class="points-alternate points-below">
        {{ 'productPrices.earnPoints.lite' | translateSafe : { points: line.points } }}
    </div>
</div>
